import React from "react"

import { Button } from "components"

interface SitePlanColorPickerProps {
 isShown: boolean
 borderColor: string
 setBorderColor: (_value: string) => void
 cursorColor: string
 setCursorColor: (_value: string) => void
 bodyColor: string
 setBodyColor: (_value: string) => void
 setIsShown: (_value: boolean) => void
}

export const SitePlanColorPicker: React.FC<SitePlanColorPickerProps> = ({
 isShown,
 borderColor,
 setBorderColor,
 cursorColor,
 setCursorColor,
 bodyColor,
 setBodyColor,
 setIsShown,
}: SitePlanColorPickerProps) => {
 return (
  <React.Fragment>
   {isShown && (
    <div className="flex flex-col fixed top-32 bg-gray rounded py-3 px-3 left-[27%] z-50 w-[10%]">
     <div>
      <h1>Grid Lines</h1>
      <input
       className="w-full"
       type="color"
       value={borderColor}
       onChange={(e) => setBorderColor(e.target.value)}
       aria-label="Pick a color"
      />
     </div>
     <div>
      <h1>Cursor</h1>
      <input
       className="w-full"
       type="color"
       value={cursorColor}
       onChange={(e) => setCursorColor(e.target.value)}
       aria-label="Pick a color"
      />
     </div>
     <div>
      <h1>Background</h1>
      <input
       type="color"
       value={bodyColor}
       className="w-full"
       onChange={(e) => setBodyColor(e.target.value)}
      />
     </div>

     <div className="mt-1.5">
      <Button
       size={"md"}
       color={"white"}
       onClick={() => {
        setIsShown(false)
       }}
      >
       Close
      </Button>
     </div>
    </div>
   )}
  </React.Fragment>
 )
}
